export const CARDS_DATA = [
  { id: 1, name: 'El Gallo', image: '1 el gallo-min.jpg' },
  { id: 2, name: 'El Diablito', image: '2 el diablito-min.jpg' },
  { id: 3, name: 'La Dama', image: '3 la dama-min.jpg' },
  { id: 4, name: 'El Catrín', image: '4 el catrin-min.jpg' },
  { id: 5, name: 'El Paraguas', image: '5 el paraguas-min.jpg' },
  { id: 6, name: 'La Sirena', image: '6-la-sirena-min.jpg' },
  { id: 7, name: 'La Escalera', image: '7 la escalera-min.jpg' },
  { id: 8, name: 'La Botella', image: '8 la botella-min.jpg' },
  { id: 9, name: 'El Barril', image: '9 barril-min.jpg' },
  { id: 10, name: 'El Árbol', image: '10 arbol-min.jpg' },
  { id: 11, name: 'El Melón', image: '11 melon-min.jpg' },
  { id: 12, name: 'El Valiente', image: '12 el valiente-min.jpg' },
  { id: 13, name: 'El Gorrito', image: '13 el gorrito-min.jpg' },
  { id: 14, name: 'La Muerte', image: '14 la muerte-min.jpg' },
  { id: 15, name: 'La Pera', image: '15 la pera-min.jpg' },
  { id: 16, name: 'La Bandera', image: '16 la bandera-min.jpg' },
  { id: 17, name: 'El Bandolón', image: '17 el bandolon-min.jpg' },
  { id: 18, name: 'El Violoncello', image: '18 el violoncello-min.jpg' },
  { id: 19, name: 'La Garza', image: '19 la garza-min.jpg' },
  { id: 20, name: 'El Pájaro', image: '20 el pajaro-min.jpg' },
  { id: 21, name: 'La Mano', image: '21 la mano-min.jpg' },
  { id: 22, name: 'La Bota', image: '22 la bota-min.jpg' },
  { id: 23, name: 'La Luna', image: '23 la luna-min.jpg' },
  { id: 24, name: 'El Cotorro', image: '24 el cotorro-min.jpg' },
  { id: 25, name: 'El Borracho', image: '25 el borracho-min.jpg' },
  { id: 26, name: 'El Negrito', image: '26 el negrito-min.jpg' },
  { id: 27, name: 'El Corazón', image: '27 el corazon-min.jpg' },
  { id: 28, name: 'La Sandía', image: '28 la sandia-min.jpg' },
  { id: 29, name: 'El Tambor', image: '29 el tambor-min.jpg' },
  { id: 30, name: 'El Camarón', image: '30 el camaron-min.jpg' },
  { id: 31, name: 'Las Jaras', image: '31 las jaras-min.jpg' },
  { id: 32, name: 'El Músico', image: '32 el musico-min.jpg' },
  { id: 33, name: 'La Araña', image: '33 la ara+¦a-min.jpg' },
  { id: 34, name: 'El Soldado', image: '34 el soldado-min.jpg' },
  { id: 35, name: 'La Estrella', image: '35 la estrella-min.jpg' },
  { id: 36, name: 'El Cazo', image: '36 el cazo-min.jpg' },
  { id: 37, name: 'El Mundo', image: '37 el mundo-min.jpg' },
  { id: 38, name: 'El Apache', image: '38 el apache-min.jpg' },
  { id: 39, name: 'El Nopal', image: '39 el nopal-min.jpg' },
  { id: 40, name: 'El Alacrán', image: '40 el alacran-min.jpg' },
  { id: 41, name: 'La Rosa', image: '41 la rosa-min.jpg' },
  { id: 42, name: 'La Calavera', image: '42 la calavera-min.jpg' },
  { id: 43, name: 'La Campana', image: '43 la campana-min.jpg' },
  { id: 44, name: 'El Cantarito', image: '44 el cantarito-min.jpg' },
  { id: 45, name: 'El Venado', image: '45 el venado-min.jpg' },
  { id: 46, name: 'El Sol', image: '46 el sol-min.jpg' },
  { id: 47, name: 'La Corona', image: '47 la corona-min.jpg' },
  { id: 48, name: 'La Chalupa', image: '48 la chalupa-min.jpg' },
  { id: 49, name: 'El Pino', image: '49 el pino-min.jpg' },
  { id: 50, name: 'El Pescado', image: '50 el pescado-min.jpg' },
  { id: 51, name: 'La Palma', image: '51 la palma-min.jpg' },
  { id: 52, name: 'La Maceta', image: '52 la maceta-min.jpg' },
  { id: 53, name: 'El Arpa', image: '53 el arpa-min.jpg' },
  { id: 54, name: 'La Rana', image: '54 la rana-min.jpg' },
];
